<template>
  <div>
    <div v-if="element.implantedAt">
      <strong>{{ $t('activerecord.attributes.element.implanted_at') }}</strong>
      {{ $d(element.implantedAt, 'date') }}
      <template v-if="element.implantationMode"> ({{ $t(`activerecord.attributes.element/implantation_mode.${element.implantationMode}`) }})</template>
    </div>

    <div v-if="element.removedAt">
      <strong>{{ $t('activerecord.attributes.element.removed_at') }}</strong>
      {{ $d(element.removedAt, 'date') }}
    </div>
  </div>
</template>

<script>
import Element from '../../../classes/models/Element'

export default {
  name: 'ElementContent',
  props: {
    element: { required: true, type: Element },
  },
}
</script>
